const FeatureCardHome = ({ imageSrc, title, description }) => (
  <div
    className="relative rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden h-[400px] flex items-center justify-center text-center"
    style={{ backgroundImage: `url(${imageSrc})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
  >
    {/* Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-50"></div>

    {/* Content */}
    <div className="relative z-10 p-6">
      <h3 className="text-2xl font-semibold text-white mb-4">{title}</h3>
      <p className="text-white">{description}</p>
    </div>
  </div>
);

export default FeatureCardHome